const namespacesToMethodAccess = require('./namespacesToMethodAccess');
const namespaces = [
    { title: 'ns', prettyName: 'ns', relations: [{ title: 'rel', prettyName: 'rel' }] },
    // declare for dropDown foreignNamespace and foreignRelation:
    { title: 'ns2', prettyName: 'ns2', relations: [{ title: 'rel2', prettyName: 'rel2' }] }
];
module.exports = function embedInUseCase(pageJSON, userAccess = { patch: false }, _namespaces = namespaces) {
    return {
        _id: 'null',
        title: 'testUcRestricted',
        featureFlags: [],
        release: '1.0.0',
        'metaui:useCase': { title: 'testUc', _id: '8'.repeat(24) },
        namespaces: namespacesToMethodAccess(_namespaces, userAccess),
        hierarchies: [],
        topMenu: [],
        hNodes: {
            id: 'bb6377b744ab7c497b136b7ca3',
            viewport: ['all'],
            hNodeType: 'LeftSideNavAppLayout',
            hNodeTypeGroup: 'appLayout',
            blockId: 'G{!Wu.x`d8B_j3Obn:?F',
            title: 'testAppLayout',
            children: Array.isArray(pageJSON) ? pageJSON : [pageJSON]
        },
        blockId: 'Q-m:Z]qMnJE}aVLeEWK9'
    };
};
